import React from 'react';
import Menu from 'react-burger-menu/lib/menus/slide';
import './styles.scss';
import {
  Button,
  Collapse,
  Well,
  Row,
  Col,
  OverlayTrigger,
  Popover
} from 'react-bootstrap';
import { getItemLink, SECTIONS_DATA } from '../igroadmap_components/constants';
import StartupInfo from './StartupInfo';
import BrandLogo from './BrandLogo';
import { injectIntl } from 'react-intl';
import { bmMenuWrapStyle, pushElements } from './functions';
import { INSTRUCTIONAL_SIDEBAR_KEYS, STANDARD_SECTIONS } from './constants';
import { INSTRUCTIONAL_ROUTES } from '../instructional_feed_components/constants';

@injectIntl
export default class Main extends React.Component {
  constructor(props, context) {
    super(props, context);

    const sectionsCollection = {};
    [...SECTIONS_DATA].map(
      ([, section]) => (sectionsCollection[section.name] = false)
    );

    const isMobile = window.matchMedia('only screen and (max-width: 768px)')
      .matches;

    const openSidebarState =
      localStorage.getItem('openSidebar') == null
        ? !isMobile
        : localStorage.getItem('openSidebar');

    this.state = {
      open: null,
      hovered: null,
      isMobile: isMobile,
      sidebarOpen: isMobile ? false : openSidebarState == 'open'
    };
  }

  renderBlock = section => {
    const { tools } = section;

    const { toolsPaths, intl } = this.props;
    const route = getItemLink(name, toolsPaths);

    return (
      <Collapse in={this.state.open == section.name}>
        <Well>
          {tools.map((el, id) => (
            <div key={id} className="well-item">
              <a
                className="sidebar-option"
                style={{ display: 'block' }}
                href={toolsPaths[`${el.prefix || ''}${el.name}`]}
                onClick={() => this.setState({ sidebarOpen: false })}
                title={intl.formatMessage({ id: `${el.name}_help` })}
              >
                <span>
                  <i
                    style={{
                      color: '#2ebb9a',
                      minWidth: '35px'
                    }}
                    className={el.icon}
                  />
                  {intl.formatMessage({ id: `${el.name}` })}
                </span>
              </a>
            </div>
          ))}
        </Well>
      </Collapse>
    );
  };

  renderArrow = section => (
    <i
      className={`fa fa-arrow-${this.state.open == section.name ? 'up' : 'down'
        }`}
      onClick={() =>
        this.setState({
          open: this.state.open != section.name ? section.name : null
        })
      }
    />
  );

  renderItem = section => {
    const { name, icon } = section;
    const { intl, toolsPaths } = this.props;
    const route = getItemLink(name, toolsPaths);
    const isHomeRoute =
      name == 'home' ||
      name == 'create_startup' ||
      name == 'gravitas' ||
      name == 'homer';

    return (
      <div
        className="sidebar-option"
        onMouseOver={() => this.setState({ hovered: name })}
        onMouseLeave={() => this.setState({ hovered: null })}
      >
        <OverlayTrigger
          trigger={['hover', 'focus']}
          placement="right"
          overlay={
            <Popover id="popover-positioned-right" style={{ zIndex: 100000 }}>
              {isHomeRoute ? intl.formatMessage({ id: 'click_here' }) : ''}

              {intl.formatMessage({
                id: `${name}${isHomeRoute ? '_sidebar' : '_popover'}`
              })}
            </Popover>
          }
        >
          <a
            href={!isHomeRoute ? route : toolsPaths[name]}
            target={section.name === 'gravitas' ? "_blank" : undefined}
            style={{ paddingRight: '16px' }}
            className={['home', 'gravitas', 'homer'].includes(section.name) ? 'is-important' : ''}
            onClick={() => this.setState({ sidebarOpen: false })}
          >
            <i
              style={{ color: '#2ebb9a', minWidth: '35px' }}
              className={icon}
            />
            {intl.formatMessage({
              id: `${name}${isHomeRoute ? '' : '_section'}`
            })}

            {section.name === 'gravitas' && <i className="file-icon fa fa-external-link _blank"></i>}
          </a>
        </OverlayTrigger>

        {this.state.hovered == section.name &&
          (!['create_startup', 'gravitas', 'homer'].includes(section.name) && (
            <a
              href={
                section.name == 'home'
                  ? `/${intl.locale}/tour`
                  : `${toolsPaths[INSTRUCTIONAL_SIDEBAR_KEYS[section.name]]
                  }?modal=${section.name}`
              }
              title={intl.formatMessage({ id: 'what_is_it' })}
              onClick={() => this.setState({ sidebarOpen: false })}
            >
              <i style={{ color: '#2ebb9a' }} className="fa fa-question" />
            </a>
          ))}

        {!isHomeRoute && this.renderArrow(section)}
      </div>
    );
  };

  sidebarItem = (section, key) => {
    if (section.name == 'create_startup' && !this.props.isPremium) return null;

    return (
      <div key={key} className="sidebar-item">
        {this.renderItem(section)}
        {this.renderBlock(section)}
        {section.name !== 'startup' && <hr style={{ height: 1 }} />}
      </div>
    );
  };

  handleOpenSidebar = state => {
    if (this.state.isMobile) return;

    localStorage.setItem('openSidebar', state.isOpen ? 'open' : 'close');

    const marginLeft = state.isOpen ? this.MARGIN_LEFT : '0px';
    const display = state.isOpen ? 'none' : 'unset';

    pushElements(marginLeft, display);
  };

  componentDidMount() {
    this.MARGIN_LEFT = [
      ...document.getElementsByClassName('bm-menu-wrap')
    ][0].style.width;
    const marginLeft = this.MARGIN_LEFT;
    const display = 'none';

    window.addEventListener('resize', () => {
      const isMobile = window.matchMedia('only screen and (max-width: 768px)')
        .matches;
      this.setState({ isMobile: isMobile });
    });

    if (!this.state.isMobile && this.state.sidebarOpen)
      pushElements(marginLeft, display);
  }

  render() {
    const styles = {
      bmMenuWrap: bmMenuWrapStyle()
    };

    return (
      <Menu
        noOverlay={!this.state.isMobile}
        isOpen={this.state.sidebarOpen}
        onStateChange={this.handleOpenSidebar}
        {...this.props}
        styles={styles}
        customCrossIcon={<i className="fa fa-arrow-left" />}
      >
        <BrandLogo ignisLogo={this.props.ignisLogo} />
        <StartupInfo
          startup={this.props.startup}
          imageUrl={this.props.imageUrl}
        />
        {STANDARD_SECTIONS.map((section, key) =>
          this.sidebarItem(section, key)
        )}
        {[...SECTIONS_DATA].map(([, section], key) =>
          this.sidebarItem(section, key)
        )}
      </Menu>
    );
  }
}
